import * as React from 'react'
import { useTranslation } from '../../../hooks/useTranslation'
import { NameCell } from './NameCell'
import { DateCell } from './DateCell'
import { TypeCell } from './TypeCell'
import { ViewCell } from './ViewCell'
import { DownloadCell } from './DownloadCell'
import { DeleteCell } from './DeleteCell'
import { EmailCell } from './EmailCell'
import Filters from './Filters'
import { useIsMobile } from '~/hooks/useMediaQuery'

export const columns = [
  {
    accessorKey: 'name',
    header: (props) => <TableHeader {...props} />,
    cell: (props) => <NameCell {...props} />,
    enableSorting: false,
    filterFn: (row, _columnId, filterValue) => {
      if (filterValue) {
        const filterDate = new Date(filterValue).setHours(0, 0, 0, 0)
        const chatDate = new Date(row.original.started_at).setHours(0, 0, 0, 0)
        return chatDate === filterDate
      }
      return true
    },
  },
  {
    accessorKey: 'started_at',
    header: (props) => <TableHeader {...props} />,
    cell: (props) => <DateCell {...props} />,
    sortingFn: 'datetime',
  },
  {
    accessorKey: 'chat_type',
    header: (props) => <TableHeader {...props} />,
    cell: (props) => <TypeCell {...props} />,
    sortingFn: 'alphanumeric',
  },
  {
    accessorKey: 'view',
    header: (props) => <BlankHeader {...props} />,
    cell: (props) => <ViewCell {...props} />,
    enableSorting: false,
  },
  {
    accessorKey: 'email',
    header: (props) => <BlankHeader {...props} />,
    cell: (props) => <EmailCell {...props} />,
    enableSorting: false,
  },
  {
    accessorKey: 'download',
    header: (props) => <BlankHeader {...props} />,
    cell: (props) => <DownloadCell {...props} />,
    enableSorting: false,
  },
  {
    accessorKey: 'delete',
    header: (props) => <BlankHeader {...props} />,
    cell: (props) => <DeleteCell {...props} />,
    enableSorting: false,
  },
]

function TableHeader({ column, ...props }) {
  const isMobile = useIsMobile()
  const { t } = useTranslation('TableHeader')
  if (isMobile) return <MobileHeader column={column} {...props} />
  return <div className="subtitle">{t(column.id)}</div>
}

function BlankHeader() {
  return <div className="font-roboto"></div>
}

function MobileHeader({ column, ...props }) {
  const { t } = useTranslation('TableHeader')
  return (
    <div className="flex items-center justify-between">
      <div className="subtitle">{t(column.id)}</div>
      <div className="flex items-center gap-2">
        <Filters {...props} />
      </div>
    </div>
  )
}
